<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import {getUserId, removeUserId} from '@/utils/cookie'
  export default {
    name: 'app',
    data(){
      return{
        beforeUnload: '',
        Handler: ''
      }
    },
    created() {

    },
    mounted() {
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.addEventListener('unload', e => this.unloadHandler(e))
    },
    destroyed() {
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.removeEventListener('unload', e => this.unloadHandler(e))
    },
    methods: {
      //窗口关闭清除cookies监听事件
      beforeunloadHandler(){
        this.beforeUnload =new Date().getTime();
      },
      unloadHandler(e){
        this.Handler=new Date().getTime()-this.beforeUnload;
        //判断是窗口关闭还是刷新
        if(this.Handler<=5){
          if(localStorage.getItem('web_login_time')){

          }else{
            removeUserId()
            localStorage.removeItem("web_user");
            localStorage.removeItem("web_login_time");
            localStorage.removeItem("web_login_password");
            localStorage.removeItem("create_click_bg");
            localStorage.removeItem("web_login_user");
            localStorage.removeItem("click_route");
            localStorage.removeItem("create_order_pro");
            // localStorage.clear();
          }
        }else{
        }
      },

    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue